import { ApiNotification } from '@/data'
import { BasicAuthServiceHelper } from '../Auth'
import { AppDispatch } from '@/store'
import { ApiNotificationsTypes } from './ApiNotificationsReducer'
import { ReadNotification } from '@/modules/ApiNotifications/apiTypes'

export const setReadNotification = async (notification: ApiNotification): Promise<ApiNotification> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<ReadNotification.Response, ReadNotification.Body>(
    ReadNotification.Route(notification),
    {
      body: {
        status: 'read',
      },
    },
  )
}

export const setMultipleReadNotifications = async (notifications: ApiNotification[]): Promise<ApiNotification[]> => {
  return await Promise.all(notifications.map(setReadNotification))
}

export const dispatchAsyncMultipleReadNotifications =
  (dispatch: AppDispatch) =>
  async (notifications: ApiNotification[]): Promise<ApiNotification[]> => {
    const newNotifications = await setMultipleReadNotifications(notifications)
    notifications.forEach((n) => dispatch({ type: ApiNotificationsTypes.Remove, payload: n.id }))
    return newNotifications
  }

export const dispatchAddNotification = (dispatch) => (notification: ApiNotification) => {
  dispatch({ type: ApiNotificationsTypes.Add, payload: notification })
}
